export default {
  getAppVoucherList: {
    method: 'get',
    url: 'app/voucher/list'
  },
  createAppVoucher: {
    method: 'post',
    url: 'app/voucher/create'
  },
  getAppVoucherOrder: {
    method: 'get',
    url: 'app/voucher/order'
  },
  exportVoucher: {
    method: 'post',
    url: 'app/voucher/list/export'
  },
  exportVoucherOrder: {
    method: 'post',
    url: 'app/voucher/order/export'
  }
}
